import { DeliveriesFilters, DeliveriesSortField, HistoricalSwitch } from 'api/models/Deliveries';
import { SortOrder } from 'api/models/Sorting';
import { atom, useAtom } from 'jotai';

export const DELIVERIES_INITIAL_FILTERS: DeliveriesFilters = {
  sort_order: SortOrder.Descending,
  sort_by: DeliveriesSortField.SurgeryDate,
  historical: HistoricalSwitch.Active,
};

const deliveriesFiltersAtom = atom(DELIVERIES_INITIAL_FILTERS);

export const useDeliveriesFilters = () => useAtom(deliveriesFiltersAtom);
